module.exports = "/_next/static/images/mechanical-06429f2fd25e8905900fad17fa7eb449.webp";